import { FormElement } from "./createFormStructure";
interface CreateFormEmailProps {
  formStructure: FormElement[];
}

export const flattenFormStructure = ({
  formStructure,
}: CreateFormEmailProps): FormElement[] => {
  const flattenedFields: FormElement[] = [];

  for (const field of formStructure) {
    switch (field.type) {
      case "fieldset":
      case "column":
        flattenedFields.push(
          ...flattenFormStructure({ formStructure: field.children || [] }),
        );
        break;
      default:
        flattenedFields.push(field);
    }
  }

  return flattenedFields;
};
